import React, { Component, Fragment } from "react";
import Skittle from "../../../../d3Components/skittlesChart/skittle";
import alasql from "alasql";
import _ from "lodash";
import $ from "jquery";
import colors from "../AssetClass/section1/colors.json";

class SkittleHolder extends Component {
  state = {
    yearlyHeading2: [],
    yearlyData2: [],
    monthlyData2: [],
    monthlyHeading2: [],
    containerWidth: 0,
    ch2_DrillDownData: {},
  };
  componentDidMount() {
    this.modifyData({ data: this.props.res });
  }
  componentWillReceiveProps(nextProps) {
    this.modifyData({ data: nextProps.res });
  }
  modifyData = ({ data }) => {
    if (!data) return;
    var pd = data.getPortfolioData;
    // year wise data
    var uniqueDates = alasql("select distinct dt from ?", [pd]);
    var byYear = alasql(
      "select SUBSTRING(dt,1,4) as dt, allocation::NUMBER as allocation, style,fund_asset_class_focus from ?",
      [pd]
    );
    var byAssetClass = alasql(
      "select dt, fund_asset_class_focus,MAX(allocation) as allocation from ? group by dt, fund_asset_class_focus",
      [byYear]
    );
    var byStyle = alasql(
      "select dt,style, MAX(allocation) as allocation from ? group by dt, style",
      [byYear]
    );
    // Month wise data
    var byMonths = alasql(
      "select dt,allocation::NUMBER as allocation, style, fund_asset_class_focus from ?",
      [pd]
    );
    var byAssetClassMonths = alasql(
      "select dt, fund_asset_class_focus,MAX(allocation) as allocation from ? group by dt, fund_asset_class_focus",
      [byMonths]
    );
    var byStyleMonths = alasql(
      "select dt,style, MAX(allocation) as allocation from ? group by dt, style",
      [byMonths]
    );

    // set of colors
    let NewColors = colors;
    // *********functions ********//
    // array of arrays function
    function resultArray(data, yrs, groupBy_text) {
      let result = _(data)
        .groupBy(groupBy_text)
        .map((objs, key) => [
          key,
          ...yrs.map(
            (year) =>
              _.sumBy(
                _.filter(objs, (obj) => obj.dt === year),
                "allocation"
              ).toFixed(2) + "%"
          ),
        ])
        .value();
      let symbol = [];
      result.map((d) => {
        symbol.push(symbolRE(getShortSymbol(d[0])));
      });
      result.map((d, i) => {
        d.push(NewColors[i], symbol[i]);
      });
      return result;
    }

    // text splitting
    function getShortSymbol(str) {
      return str
        .replace(/\b(\w{1,2})(\w+\s?|\s)/g, "$1 ")
        .toUpperCase()
        .slice(0, -1);
    }
    function symbolRE(str) {
      let string = str;
      if (string.toString().length > 6) {
        let j = string.slice(0, 6);
        return j;
      } else {
        return string;
      }
    }

    // unique dates
    function distinct_Dates(data) {
      return _.uniqBy(data, "dt").map((obj) => obj.dt);
    }

    // header data
    function getHeader(yrs) {
      let temp = ["Asset Class"];
      yrs.map((years) => {
        temp.push(years);
      });
      temp = [...temp, "color code", "short code"];
      return temp;
    }

    // Drill down data function
    function getDrilleDownData(years, data, txt) {
      let YearWiseData = { data: {}, header: {} };
      years.forEach((yrs) => {
        YearWiseData.data[yrs] = resultArray(
          alasql(
            `select dt,allocation, ${txt} from ? where dt LIKE "${yrs}%" `,
            [data]
          ),
          alasql(`select distinct dt from ? where dt LIKE "${yrs}%"`, [
            byStyleMonths,
          ]).map((d) => {
            return d.dt;
          }),
          txt
        );
        YearWiseData.header[yrs] = getHeader(
          alasql(`select distinct dt from ? where dt LIKE "${yrs}%"`, [
            byStyleMonths,
          ]).map((d) => {
            return d.dt;
          })
        );
      });
      return YearWiseData;
    }

    //********* CHART2 YEARLY DATA ***********//
    var ch2_years = distinct_Dates(byStyle);
    var yearlyData2 = resultArray(byStyle, ch2_years, "style");
    // heading 2 Yearly data
    let yearlyHeading2 = getHeader(ch2_years);

    // *** CHART2 Monthly Data *** //
    var uniqueMonths2 = distinct_Dates(byStyleMonths);
    var resultMonthly2 = resultArray(byStyleMonths, uniqueMonths2, "style");
    // monthlyHeading2 data
    let monthlyHeading2 = getHeader(uniqueMonths2);

    // ******** Drill down chart data ********* //

    let YearWiseData2 = getDrilleDownData(ch2_years, byStyleMonths, "style");
    let containerWidth = $(".container-fluid").width() / 100;

    this.setState({
      yearlyHeading2,
      yearlyData2,
      monthlyData2: resultMonthly2,
      monthlyHeading2,
      containerWidth: containerWidth * 100 - 100,
      ch2_DrillDownData: YearWiseData2,
    });
  };
  render() {
    // **** getting Max length of stack *****
    //  getting altered array
    function get_modifiedArr(arr_data) {
      let arr = [];
      if (arr_data && arr_data[1]) {
        for (let i = 1; i < arr_data[1].length - 2; i++) {
          arr.push(arr_data.map((x) => x[i]));
        }
      }
      return arr;
    }
    //  getting length excluding 0's
    function get_length(exclude) {
      var excluded_data = exclude.map((arr) =>
        arr.filter((el) => el !== "0.00%")
      );
      let len = [];
      excluded_data.map((arr, i) => {
        len.push(arr.length);
      });
      return Math.max(...len);
    }
    const {
      yearlyHeading2,
      yearlyData2,
      containerWidth,
      monthlyData2,
      monthlyHeading2,
      ch2_DrillDownData,
    } = this.state;
    return (
      <Fragment>
        <div>
          {yearlyData2.length > 0 && yearlyHeading2.length > 0 ? (
            <Skittle
              id={"skittler2"}
              canvasId={"pa2"}
              data={yearlyHeading2.length > 8 ? yearlyData2 : monthlyData2}
              heading={
                yearlyHeading2.length > 8 ? yearlyHeading2 : monthlyHeading2
              }
              height={
                yearlyHeading2.length > 8
                  ? get_length(get_modifiedArr(yearlyData2)) * 24 + 200
                  : get_length(get_modifiedArr(monthlyData2)) * 24 + 200
              }
              width={
                yearlyHeading2.length > 8
                  ? (get_length(yearlyData2) - 2.2) * 120
                  : (get_length(monthlyData2) - 2.2) * 120
              }
              // height={yearlyData2.length * 24 + yearlyData2.length * 4 + 250}
              containerWidth={containerWidth}
              displayEmptyBlock={false}
              YearWiseData={ch2_DrillDownData}
            />
          ) : null}
        </div>
      </Fragment>
    );
  }
}

export default SkittleHolder;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Component page/StyleExposure/skittleHolder.jsx